import { useCallback } from "react"
import posthog from 'posthog-js'

// Ancien wizard — plus émis depuis le lot 3 (WizardRouter n'est plus monté ; lot 9).
type WizardEvent =
  | 'wizard_started'
  | 'wizard_step_completed'
  | 'wizard_completed'
  | 'wizard_abandoned'

// Diagnostic v2 (lot 3). Aucune propriété de blessure, jamais : ce sont des données de
// santé, et PostHog est un tiers.
//   diagnostic_block_completed { block: 'toi' | 'pratique' | 'objectif' }
//   diagnostic_completed       { level_id, goal_id, place }
type DiagnosticEvent =
  | 'diagnostic_started'
  | 'diagnostic_block_completed'
  | 'diagnostic_completed'

// Activation et engagement
type EngagementEvent =
  | 'dashboard_first_view'
  | 'hooper_filled'
  | 'session_started'
  | 'session_completed'
  | 'nutrition_viewed'
  | 'calendar_event_created'
  | 'streak_achieved'

// Monétisation
//
// Les trois étapes de la semaine d'essai — `trial_started`, `trial_ended`,
// `trial_converted` — ne sont PAS déclarées ici : elles sont émises CÔTÉ SERVEUR
// (edge functions start-trial, trial-lifecycle, stripe-webhook). Une étape qui
// engage un droit ou de l'argent ne doit dépendre ni du consentement analytics,
// ni d'un onglet fermé trop tôt.
//
// Elles remplacent `trial_activated` (client) et `trial_consumed` (client), ainsi
// que `trial_session_created` (émis par create-trial-session, plus appelée).
type MonetizationEvent =
  | 'checkout_started'
  | 'checkout_completed'
  | 'subscription_canceled'
  | 'ebook_purchased'

// Compte — « mot de passe oublié ». Jamais l'email ni le mot de passe en propriété.
//   password_reset_requested   { from_app: boolean }
//   password_reset_completed   { from_app: boolean }
//   password_reset_link_expired
//   password_reset_other_account  (lien ouvert dans un navigateur connecté à un autre compte)
type AccountEvent =
  | 'password_reset_requested'
  | 'password_reset_completed'
  | 'password_reset_link_expired'
  | 'password_reset_other_account'

// Push notifications
type PushEvent =
  | 'push_permission_requested'
  | 'push_subscribed'
  | 'push_unsubscribed'
  | 'push_preference_toggled'

/**
 * Source de vérité des événements analytics.
 * 26 events au total : 4 Wizard (plus émis) + 3 Diagnostic + 7 Engagement + 4 Monétisation + 4 Compte + 4 Push.
 * Les événements serveur (trial_started / trial_ended / trial_converted) ne sont
 * pas typés ici : ils ne passent jamais par posthog-js.
 * Toute modification doit être reflétée dans docs/sessions/CONTEXTE_VX.md
 */
export type AnalyticsEvent = WizardEvent | DiagnosticEvent | EngagementEvent | MonetizationEvent | AccountEvent | PushEvent

export function useAnalytics() {
  const track = useCallback((event: AnalyticsEvent, properties?: Record<string, unknown>) => {
    posthog.capture(event, properties)
  }, [])

  return { track }
}
